import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { TipoLancamento } from '@models/tipo-lancamento';

@Injectable({
  providedIn: 'root'
})
export class TipoLancamentoApiService extends ApiService {

  constructor(public override http: HttpClient) {
    super(http);
  }

  public getTiposLancamento(): Observable<TipoLancamento[]> {
    return this.get<TipoLancamento[]>('/tipos-lancamento');
  }
}
